import { apiGet } from '../../../shared/api-client/index.js';
import { entityListKey, type EntityListKey } from '../../../shared/api/entityQueryKeys.js';
import type { DealWinProbabilitySummary } from '../../../sales-health/win-probability.js';

export type HotLeadReason =
  | 'overdue_next_activity'
  | 'missing_next_activity'
  | 'stale_activity'
  | 'overdue_task'
  | 'due'
  | 'high_value';

export interface HotLeadItem {
  deal: {
    id: string;
    title: string;
    amount: number | string;
    currency: string;
    stage: string;
    contactName: string | null;
  };
  reasons: HotLeadReason[];
  primaryReason: HotLeadReason;
  score: number;
  recommendation: 'email' | 'call';
  /**
   * On-read heuristic win probability with its top factors. The server
   * computes it in the same pass as the reasons; absent in legacy payloads.
   */
  winProbability?: DealWinProbabilitySummary;
}

export interface ListHotLeadsFilters {
  filter?: 'all' | HotLeadReason;
}

export function getHotLeadsQueryKey(
  workspaceId: string,
  filter?: 'all' | HotLeadReason,
): EntityListKey {
  return entityListKey('hot-leads', workspaceId, { filter });
}

export async function listHotLeads(filters: ListHotLeadsFilters = {}): Promise<HotLeadItem[]> {
  const search = new URLSearchParams();
  if (filters.filter) {
    search.set('filter', filters.filter);
  }
  const path = search.size > 0 ? `/leads/hot?${search.toString()}` : '/leads/hot';
  return apiGet<HotLeadItem[]>(path);
}
